import {SurveyAnswers} from 'core/SurveyModels'

export abstract class SurveySessionStorage {
  constructor(protected storageKey: string) {}

  abstract set(answers: SurveyAnswers): void

  abstract update(answers: SurveyAnswers): void

  abstract get(): SurveyAnswers

  abstract delete(): void

  abstract isEmpty(): boolean
}
